<template>
    <div>
        <nav aria-label="Page navigation example">
            <ul class="pagination">
                <li class="page-item" :class="{ disabled: page <= 1 }">
                    <a
                        class="page-link"
                        href="#"
                        @click.prevent="onPage(page - 1)"
                        >&#10094;</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="x in getPageItems"
                    :key="x"
                    :class="{ active: page === x }"
                >
                    <a class="page-link" href="#" @click.prevent="onPage(x)">{{
                        x
                    }}</a>
                </li>
                <li
                    class="page-item"
                    :class="{ disabled: page >= getPageItems.length }"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click.prevent="onPage(page + 1)"
                        >&#10095;</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            required: true
        },
        page: {
            type: Number,
            required: true,
            default: 1
        }
    },
    computed: {
        getPageItems() {
            const pages = [];
            if (this.data.data) {
                if (this.data.total && this.data.per_page) {
                    const rows = this.data.total;
                    const limit = this.data.per_page;
                    for (
                        let index = 1;
                        index <= Math.ceil(rows / limit);
                        index++
                    ) {
                        pages.push(index);
                    }
                }
            }
            return pages;
        }
    },
    methods: {
        onPage(page) {
            this.$emit("onPage", page);
        }
    }
};
</script>
